class StepsSection {
  constructor(section) {
    this.section = section;
    this.itemsWrapper = section.querySelector('.steps__items');
    this.items = Array.from(section.querySelectorAll('.steps__item'));
    this.markers = this.items.map((item) => item.querySelector('.steps__marker-wrapper'));
    this.progressLine = section.querySelector('.steps__line--progress');
    this.visibleIndexes = new Set();

    if (!this.itemsWrapper || !this.progressLine || this.items.length === 0) return;

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      root: null,
      threshold: 0.4,
    });

    this.items.forEach((item) => this.observer.observe(item));

    window.addEventListener('resize', this.updateProgress.bind(this));
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      const index = this.items.indexOf(entry.target);
      if (index === -1) return;

      if (entry.isIntersecting) {
        entry.target.classList.add('steps__item--active');
        this.visibleIndexes.add(index);
      } else {
        entry.target.classList.remove('steps__item--active');
        this.visibleIndexes.delete(index);
      }
    });

    this.updateProgress();
  }

  updateProgress() {
    if (!this.progressLine || !this.itemsWrapper) return;

    if (this.visibleIndexes.size === 0) {
      this.progressLine.style.height = '0px';
      return;
    }

    const maxIndex = Math.max(...this.visibleIndexes);
    const marker = this.markers[maxIndex];
    if (!marker) return;

    const wrapperRect = this.itemsWrapper.getBoundingClientRect();
    const markerRect = marker.getBoundingClientRect();

    const offset = markerRect.top + markerRect.height / 2 - wrapperRect.top;
    const height = Math.max(offset, 0);

    this.progressLine.style.height = `${height}px`;
  }
}

function initStepsSections(context = document) {
  const sections = context.querySelectorAll('.section-steps');
  sections.forEach((section) => new StepsSection(section));
}

document.addEventListener('DOMContentLoaded', () => {
  initStepsSections(document);
});

document.addEventListener('shopify:section:load', (event) => {
  const container = event.target;
  if (!container) return;
  initStepsSections(container);
});

